function sazaUpdateVariantMedia(root, variant) {
  if (!root || !variant || !variant.image) return;
  var image = root.querySelector('[data-saza-gallery-image]');
  if (!image) return;
  image.setAttribute('src', variant.image);
  image.removeAttribute('srcset');
  image.setAttribute('alt', variant.imageAlt || image.getAttribute('alt') || '');
}

function sazaUpdatePurchaseState(root, variant) {
  if (!root || !variant) return;

  var price = root.querySelector('[data-saza-price]');
  var compare = root.querySelector('[data-saza-compare]');
  var save = root.querySelector('[data-saza-save]');
  var add = root.querySelector('[data-saza-add]');
  var currentOption = root.querySelector('[data-saza-current-option]');

  if (price) price.textContent = variant.price || '';
  sazaUpdateVariantMedia(root, variant);
  if (compare) {
    compare.textContent = variant.compare || '';
    compare.hidden = !variant.compare;
  }
  if (save) {
    save.textContent = variant.save || '';
    save.hidden = !variant.save;
  }
  if (currentOption) currentOption.textContent = (variant.title || '').replace(' ??? Sold out', '');
  if (add) {
    add.disabled = variant.available === false || variant.available === 'false';
    add.textContent = add.disabled ? add.dataset.soldLabel : add.dataset.addLabel;
  }
  if (variant.url && window.history && window.history.replaceState) {
    window.history.replaceState({}, '', variant.url);
  }
}

function sazaReadVariants(root) {
  var source = root && root.querySelector('[data-saza-variant-data]');
  if (!source) return [];
  try {
    return JSON.parse(source.textContent);
  } catch (error) {
    return [];
  }
}

function sazaSyncSkuPicker(root) {
  if (!root) return;

  var variants = sazaReadVariants(root);
  var sizeControl = root.querySelector('[data-saza-size]:checked');
  var setControl = root.querySelector('[data-saza-set]:checked');
  var variantInput = root.querySelector('[data-saza-variant-input]');
  if (!variants.length || !sizeControl || !setControl || !variantInput) return;

  var selectedSize = sizeControl.value;
  var selectedSet = setControl.value;
  var match = variants.find(function (variant) {
    return variant.size === selectedSize && variant.set === selectedSet;
  });

  root.querySelectorAll('[data-saza-size]').forEach(function (control) {
    var available = variants.some(function (variant) {
      return variant.size === control.value && variant.set === selectedSet && variant.available;
    });
    control.disabled = !available;
    control.closest('label').classList.toggle('is-unavailable', !available);
  });

  root.querySelectorAll('[data-saza-set]').forEach(function (control) {
    var optionVariant = variants.find(function (variant) {
      return variant.size === selectedSize && variant.set === control.value;
    });
    var available = Boolean(optionVariant && optionVariant.available);
    var setPrice = root.querySelector('[data-saza-set-price="' + control.value + '"]');
    var setCompare = root.querySelector('[data-saza-set-compare="' + control.value + '"]');
    control.disabled = !available;
    control.closest('label').classList.toggle('is-unavailable', !available);
    if (setPrice) setPrice.textContent = optionVariant ? optionVariant.price : 'Unavailable';
    if (setCompare) {
      setCompare.textContent = optionVariant ? optionVariant.compare : '';
      setCompare.hidden = !optionVariant || !optionVariant.compare;
    }
  });

  if (!match) return;
  variantInput.value = String(match.id);
  variantInput.setAttribute('value', String(match.id));
  sazaUpdatePurchaseState(root, match);

  var note = root.querySelector('[data-saza-variant-note]');
  if (note) {
    note.textContent = selectedSet === 'bundle'
      ? 'Two full-size bottles, a travel kit and a 2 ml perfume sample. Price and availability update instantly.'
      : 'One full-size bottle. Price and availability update instantly.';
  }
}

document.addEventListener('change', function (event) {
  var customControl = event.target.closest('[data-saza-size], [data-saza-set]');
  if (customControl) {
    sazaSyncSkuPicker(customControl.closest('[data-saza-product]'));
    return;
  }

  var visibleOption = event.target.closest('[data-saza-variant-option]');
  if (visibleOption) {
    var visibleRoot = visibleOption.closest('[data-saza-product]');
    if (!visibleRoot) return;
    sazaUpdatePurchaseState(visibleRoot, {
      price: visibleOption.dataset.price,
      compare: visibleOption.dataset.compare,
      save: visibleOption.dataset.save,
      available: visibleOption.dataset.available,
      title: visibleOption.dataset.title,
      url: visibleOption.dataset.url,
      image: visibleOption.dataset.image,
      imageAlt: visibleOption.dataset.imageAlt
    });
    return;
  }

  var selector = event.target.closest('[data-saza-variant-select]');
  if (!selector) return;
  var option = selector.options[selector.selectedIndex];
  var root = selector.closest('[data-saza-product]');
  if (!root || !option) return;
  sazaUpdatePurchaseState(root, {
    price: option.dataset.price,
    compare: option.dataset.compare,
    save: option.dataset.save,
    available: option.dataset.available,
    title: option.textContent,
    url: option.dataset.url,
    image: option.dataset.image,
    imageAlt: option.dataset.imageAlt
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-saza-sku-picker]').forEach(function (picker) {
    sazaSyncSkuPicker(picker.closest('[data-saza-product]'));
  });
});
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-saza-quantity]');
  if (!button) return;
  var wrapper = button.closest('.saza-pdp__quantity');
  var input = wrapper && wrapper.querySelector('input');
  if (!input) return;
  var next = Number(input.value || 1) + Number(button.dataset.sazaQuantity);
  input.value = Math.max(1, next);
});
